// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9446af7e","455":"af924572"}[chunkId] + ".chunk.js";
};